import { Injectable } from '@angular/core';
import { FontType } from '@models/generic/font-type.type';

@Injectable({
  providedIn: 'root',
})
export class FontService {
  private loadedFonts: { [key: string]: ArrayBuffer } = {};

  constructor() {}

  async loadFont(family: string, font: FontType) {
    let fullFont = `${family}-${font}`;
    if (this.loadedFonts[fullFont] === undefined) {
      this.loadedFonts[fullFont] = await fetch(
        `assets/fonts/${fullFont}.ttf`,
      ).then((res) => res.arrayBuffer());
    }

    return this.loadedFonts[fullFont];
  }

  getFont(family: string, font: FontType) {
    let fullFont = `${family}-${font}`;
    return this.loadedFonts[fullFont];
  }

  hasFont(family: string, font: FontType) {
    let fullFont = `${family}-${font}`;
    return this.loadedFonts[fullFont] !== undefined;
  }
}
